import React from 'react';
import PropTypes from 'prop-types';

const ImeiSearchResult = ({result, imei, date}) => {
  return (
    <div className="inner2">

      <ul className="list-items result-list">
        <li>
          <dl className="adj-clear">
            <dt className="adj-fleft">IMEI</dt>
            <dd id="result-imei" className="adj-fleft">{imei}</dd>
          </dl>
        </li>
        <li>
          <dl className="adj-clear">
            <dt className="adj-fleft">結果</dt>
            <dd id="search-result" className="adj-fleft">{result}</dd>
          </dl>
        </li>
      </ul>
      <p className="adj-right text-small">{date.getFullYear()}年{(date.getMonth() + 1)}月{date.getDate()}日時点</p>

      <div className="adj-mt-40 area-info-attention">
        <dl className="area-table">
          <dt>○：</dt>
          <dd><p>利用可能</p>
            <p className="adj-mt-4 text-small">※ただし今後不正契約等が認められた場合、利用制限となる可能性があります。</p>
          </dd>
        </dl>

        <dl className="area-table adj-mt-16">
          <dt>△：</dt>
          <dd><p>利用可能ですが、代金債務不履行等により利用制限となる可能性があります。</p></dd>
        </dl>

        <dl className="area-table adj-mt-16">
          <dt>×：</dt>
          <dd><p>利用制限中</p></dd>
        </dl>

        <dl className="area-table adj-mt-16">
          <dt>－：</dt>
          <dd><p>IMEIが確認できません</p></dd>
        </dl>

      </div>

      <div className="adj-mt-40"><a href="./" className="btn-prev btn-link">前の画面に戻る</a></div>
    </div>
  );
};

ImeiSearchResult.propTypes = {
  result: PropTypes.string.isRequired,
  imei: PropTypes.string.isRequired,
  date: PropTypes.object.isRequired
};

export default ImeiSearchResult;
